var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXeuArrivalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7821 28.8765C42.093 29.1356 41.4268 29.1937 40.8042 29.0507L1.71733 22.3617C1.60516 22.3416 1.50672 22.2791 1.43804 22.1897C1.4037 22.145 1.37623 22.0936 1.3625 22.0378C1.35334 22.002 1.34876 21.964 1.34647 21.9283C1.32816 21.5731 0.831388 16.2335 0.501735 12.6968C0.487999 12.5449 0.556677 12.4042 0.678008 12.3193C0.765 12.2634 0.957297 12.183 1.0626 12.1964L2.26904 12.3617C2.47508 12.4131 2.61472 12.5136 2.75208 12.6119C2.79328 12.641 2.8322 12.67 2.86196 12.6857C2.97643 12.7348 3.04968 12.7661 7.70146 18.4274C7.73351 18.4408 7.78387 18.4564 7.80905 18.4609L15.6452 19.4573C15.7391 19.3501 15.7299 19.3032 15.7185 19.2496L9.2284 1.22454C9.1002 0.976546 9.15056 0.677172 9.3772 0.473865C9.4825 0.380031 9.57407 0.306305 9.64962 0.252685L9.81445 0.134276C9.97469 0.0181009 10.1647 -0.0221136 10.3593 0.0113985L12.312 0.355456C12.4357 0.353222 12.5707 0.380031 12.7195 0.449289C12.8431 0.505143 12.9988 0.587806 13.1018 0.721854L28.7787 21.0749L41.2162 22.6097C41.9236 22.7013 42.6218 22.9649 43.288 23.3984C44.4006 24.1177 45.2705 25.0136 45.472 26.0994C45.5613 26.5976 45.417 27.1026 45.0256 27.5784C44.4876 28.2308 43.4231 28.6374 42.7821 28.8787V28.8765Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXeuArrivalIcon);
export default __webpack_public_path__ + "static/media/xeu-arrival-icon.6fef2659e952e20656dafc95ccc367e5.svg";
export { ForwardRef as ReactComponent };